/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreightCalculatorTransportMethodVo
 */
export interface FreightCalculatorTransportMethodVo {
    /**
     * 序号：1-5
     * @type {number}
     * @memberof FreightCalculatorTransportMethodVo
     */
    index?: number;
    /**
     * 运输方式名称
     * @type {string}
     * @memberof FreightCalculatorTransportMethodVo
     */
    name?: string;
    /**
     * 计费方式说明
     * @type {string}
     * @memberof FreightCalculatorTransportMethodVo
     */
    chargeType?: string;
}

/**
 * Check if a given object implements the FreightCalculatorTransportMethodVo interface.
 */
export function instanceOfFreightCalculatorTransportMethodVo(value: object): value is FreightCalculatorTransportMethodVo {
    return true;
}

export function FreightCalculatorTransportMethodVoFromJSON(json: any): FreightCalculatorTransportMethodVo {
    return FreightCalculatorTransportMethodVoFromJSONTyped(json, false);
}

export function FreightCalculatorTransportMethodVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreightCalculatorTransportMethodVo {
    if (json == null) {
        return json;
    }
    return {
        
        'index': json['index'] == null ? undefined : json['index'],
        'name': json['name'] == null ? undefined : json['name'],
        'chargeType': json['chargeType'] == null ? undefined : json['chargeType'],
    };
}

export function FreightCalculatorTransportMethodVoToJSON(json: any): FreightCalculatorTransportMethodVo {
    return FreightCalculatorTransportMethodVoToJSONTyped(json, false);
}

export function FreightCalculatorTransportMethodVoToJSONTyped(value?: FreightCalculatorTransportMethodVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'index': value['index'],
        'name': value['name'],
        'chargeType': value['chargeType'],
    };
}

